import { render, staticRenderFns } from "./DetailVehicleDeliveryModal.vue?vue&type=template&id=204ee0f4&scoped=true&"
import script from "./DetailVehicleDeliveryModal.vue?vue&type=script&lang=js&"
export * from "./DetailVehicleDeliveryModal.vue?vue&type=script&lang=js&"
import style0 from "./DetailVehicleDeliveryModal.vue?vue&type=style&index=0&id=204ee0f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204ee0f4",
  null
  
)

export default component.exports